<template>
  <AdminLayout>
    <MainIndex />
    <div class="pb-16"></div>
  </AdminLayout>
</template>

<script>
// @ is an alias to /src
import AdminLayout from '@/layouts/AdminLayout.vue';
import MainIndex from '@/components/admin/membersTransactions/MainIndex.vue';

export default {
  name: 'MembersTransactions',
  components: {
    AdminLayout,
    MainIndex,
  },
};
</script>
